/**
 * Component to Add or Edit a single organization
 */
import * as React from 'react';
import { Card, Row, Col, Input, Button, message, Breadcrumb } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/OrganizationAddEdit.scss';
import Util from '../common/utils';
import service from '../../service/apolloclient.service';
import { MSGDISPLAYTIME } from '../common/constants';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
import LocalStorage from '../../service/localstorage';
import strings from '../../eyeguide-localization/organization/string.organization.add';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import UnAuthorized from '../errorPages/unauthorized';

const storage = new LocalStorage();
const EVENT = {
    ADDORG: '/organization/add/',
    EDITORG: '/organization/edit/'
};

/**
 * Property definition 
 */
interface IOrganizationProps extends IcommonProps {

    save: any;
    cancel: any;
    navigationFrom: any;
    match: any;
    location: any;
    notifyOrgStatusChange: any;
}

/**
 * State definition
 */
interface IOrganizationState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorname:    boolean;
    errorCname:    boolean;
    errorCphone:    boolean;
    errorCemail:    boolean;
    organization: any;
    name:           string;
    contactfname:    string;
    contactlname:    string;   
    contactphone:   string;
    contactemail:   any;
    address:        string;
    email:          string;
    website:        string;
    country:        string;
    region:         string;
    errorLname:     boolean;
    city:           string;
    pincode:        string;
    unAuth:         boolean;
}

export default class OrganizationAddEdit extends React.Component<IOrganizationProps, IOrganizationState> {

    constructor(props: IOrganizationProps) {
        super(props); 
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorname: false,
            errorCname: false,
            errorCemail: false,
            errorCphone: false,
            name            : '',
            contactfname    : '',
            contactlname    : '',
            contactphone    : '',
            address         : '',
            website         : '',
            contactemail    : '',
            email           : '',
            organization: [],
            country         : '' ,
            region          : '',
            city            : '',
            errorLname      : false,
            pincode         : '',
            unAuth          : false
        };
        this.processOrg = this.processOrg.bind(this);
    }

    async componentDidMount() {
        Util.resetScroll();
        console.log('componentDidUpdate');
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.ORGANIZATION);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        if (this.props.location.pathname.startsWith(EVENT.EDITORG)) {
            await this.getOrganizationToEdit(this.props.match.params.orgid);
        }
        this.setState({
            name: this.state.organization.name,
            contactfname: this.state.organization.contactfirstname,
            contactlname: this.state.organization.contactlastname,
            contactphone: this.state.organization.contactphone,
            address: this.state.organization.address,
            email: this.state.organization.email,
            website: this.state.organization.website,
            contactemail: this.state.organization.contactemail,
            country         : this.state.organization.country !== undefined ? 
                            this.state.organization.country : 'United States'  ,
            region          : this.state.organization.state,
            city            : this.state.organization.city,
            errorLname      : false,
            pincode         : this.state.organization.pincode
        });
    }

    render() { 
        // if (this.props.organization === '') { // if organization is empty, call is from Add Organization
        //     this.resetControls();
        // }
        console.log('org', this.state.organization);
        if (this.state.unAuth) {
            return (
                <UnAuthorized/>
            );
        }
        return (
            <div className="OrganizationAddEdit">
                <Card >
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/organization">{strings.lsOrgsTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {this.state.organization instanceof Array && 
                            this.state.organization.length === 0 ? strings.lsAddTxt : strings.lsEditTxt}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <br/>
                    <h3>{this.state.organization instanceof Array && 
                        this.state.organization.length === 0 ? strings.lsAddOrgTxt : strings.lsEditOrgTxt } </h3>
                </Card>
                <Card bordered={false} style={{ margin: '24px 16px' }} >
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={10} lg={6} xl={6} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsOrgName}
                                    <span className="labelReq"> * </span>
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={10} lg={10} xl={9}>
                            <Input 
                                value={this.state.name}
                                onChange={(val) => this.setState({name: val.target.value})}
                                className={this.state.errorname ? 
                                        this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. High School USA" 
                                autoFocus={true}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsContactFirstNameTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.contactfname}
                                onChange={(val) => this.setState({contactfname: val.target.value})}
                                className={this.state.errorCname ? 
                                                this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. Johnny"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsContactLastNameTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.contactlname}
                                onChange={(val) => this.setState({contactlname: val.target.value})}
                                className={this.state.errorLname ? 
                                                this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. Thomas"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">
                                <span>{strings.lsContactPhoneTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                        </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.contactphone}
                                onChange={(val) => this.setState({contactphone: val.target.value})}
                                className={this.state.errorCphone ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. 123-456-789" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">
                                <span>{strings.lsContactEmailTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                        </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input
                                value={this.state.contactemail}
                                onChange={(val) => this.setState({contactemail: val.target.value})}
                                className={this.state.errorCemail ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. johny.thomas@school.edu" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">{strings.lsAddressTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.address}
                                onChange={(val) => this.setState({address: val.target.value})}
                                placeholder="e.g. 123 At, Philadelphia, PA" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">{strings.lsCityTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.city}
                                onChange={(val) => this.setState({city: val.target.value})}
                                placeholder="e.g. Franklin" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">{strings.lsStateTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            {/* <Input 
                                value={this.state.address}
                                onChange={(val) => this.setState({address: val.target.value})}
                                placeholder="eg 123 At, Philadelphia, PA" 
                            /> */}
                            <div className="selectdiv">
                                <RegionDropdown
                                    classes="contentCountry"
                                    blankOptionLabel={strings.lsSelectRegion}
                                    defaultOptionLabel={strings.lsSelectRegion}
                                    country={this.state.country}
                                    value={this.state.region}
                                    onChange={(val) => this.selectRegion(val)} 
                                />
                            </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">{strings.lsCountryTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            {/* <Input 
                                value={this.state.address}
                                onChange={(val) => this.setState({address: val.target.value})}
                                placeholder="eg 123 At, Philadelphia, PA" 
                            /> */}
                            <div className="selectdiv">
                            <CountryDropdown
                                classes="contentCountry"
                                value={this.state.country}
                                onChange={(val) => this.selectCountry(val)} 
                            />
                            </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={6} className="labelFrame">
                        <div className="label">{strings.lsZipPostalCodeTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.pincode}
                                onChange={(val) => this.setState({pincode: val.target.value})}
                                placeholder="e.g. 10080" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} className="labelFrame">
                            <div className="label">{strings.lsOrgEmailTxt} :</div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.email}
                                onChange={(val) => this.setState({email: val.target.value})}
                                placeholder="e.g. admin@school.edu" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={5} xl={4} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} className="labelFrame">
                        <div className="label">{strings.lsWebsiteTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.website}
                                onChange={(val) => this.setState({website: val.target.value})}
                                placeholder="e.g. www.schoolsite.edu" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row>
                        <Col span={12} style={{padding: '10px'}}>
                            <div className="buttonRight"> 
                                <Button 
                                    onClick={e => {
                                        if (this.state.organization instanceof Array && 
                                                    this.state.organization.length === 0 ) {
                                            this.processOrg
                                            (this.getOrgObj(), 1, ''); // add
                                        } else {
                                            this.processOrg
                                            (this.getOrgObj(), 
                                             0, 
                                             this.state.organization.organizationid); // save
                                        }
                                    }}     
                                    type="primary" 
                                    style={{width: '100%'}}
                                > 
                                    {this.state.organization instanceof Array && 
                                            this.state.organization.length === 0 ? strings.lsAddTxt 
                                            : strings.lsSaveTxt} 
                                </Button> 
                            </div>
                        </Col>
                        <Col span={12} style={{padding: '10px'}}>
                            <div className="buttonLeft"> 
                                <Button 
                                        onClick={e => {
                                            history.back();
                                                    }} 
                                        type="danger" 
                                        style={{width: '100%'}}
                                > 
                                {strings.lsCancelTxt} 
                                </Button> 
                            </div>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }

    /**
     * Returns organization object in json format
     * to be sent to server for processing
     */
    private getOrgObj(): any {
        if (this.validateInput()) {
            let inputOrg: any = {
                'name': this.state.name !== null ? this.state.name.trim() : '',
                'contactfirstname': this.state.contactfname !== null ? this.state.contactfname.trim() : '',
                'contactlastname': this.state.contactlname !== null ? this.state.contactlname.trim() : '',
                'contactphone': this.state.contactphone !== null ? this.state.contactphone.trim() : '',
                'contactemail': this.state.contactemail !== null ? this.state.contactemail.trim() : '',
                'city': this.state.city !== null && this.state.city !== undefined
                    ? this.state.city.trim() : '',
                'state': this.state.region !== null && this.state.region !== undefined
                    ? this.state.region.trim() : '',
                'country': this.state.country !== null && this.state.country !== undefined
                    ? this.state.country.trim() : '',
                'pincode': this.state.pincode !== null && this.state.pincode !== undefined
                    ? this.state.pincode.trim() : '',
                'address': this.state.address !== null && this.state.address !== undefined
                                     ? this.state.address.trim() : '',
                'email': this.state.email !== null && this.state.email !== undefined 
                                     ? this.state.email.trim() : '',
                'website': this.state.website !== null && this.state.website !== undefined
                                     ? this.state.website.trim() : ''
                };  
            return inputOrg;
        } else {
            return '';
        }       
    }

    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorname: boolean = false;
        let errorCname: boolean = false;
        let errorCphone: boolean = false;
        let errorLname: boolean = false;
        let errorCemail: boolean = false;
        this.state.name !== null && (this.state.name === undefined || this.state.name.trim() === '') ? 
                    errorname = true : errorname = false;
        this.state.contactfname !== null && 
                (this.state.contactfname === undefined || this.state.contactfname.trim() === '') ? errorCname = true 
                    : errorCname = false;
        this.state.contactlname !== null && 
                (this.state.contactlname === undefined || this.state.contactlname.trim() === '') ? errorLname = true 
                    : errorLname = false;
        this.state.contactphone !== null && 
                    (this.state.contactphone === undefined || this.state.contactphone.trim() === '')
                    ? errorCphone = true 
                    : errorCphone = false;
        this.state.contactemail !== null &&  
                    (this.state.contactemail === undefined || this.state.contactemail.trim() === '') 
                    ? errorCemail = true 
                : errorCemail = false;
        errorCemail = errorCemail ? errorCemail : !Util.validateEmail(this.state.contactemail);
        if (errorname || errorCname || errorCphone || errorCemail || errorLname) { isValid = false; }
        this.setState({errorname, errorCname, errorCemail, errorCphone, errorLname});
        return isValid;
    }
   
    /**
     * Handles organization add / update as per the event sent.
     * @param org Organization Object to Add/Update
     * @param event Event to process. 1 - Add else Update
     * @param orgId Organization id
     */
    private async processOrg(org: any, event: number, orgId: string) {
        console.log('processOrg', storage.getSelectedOrg());
        let primary = storage.getSelectedOrg().split(',')[0];
        if (org !== '') {
            let ser = new service();
            if (event === 1) {
                let orgResponse: any = await ser.addSubOrganization(org, primary);
                if (orgResponse.status === 0) {
                    message.success(strings.lsAddOrgSuccessTxt, MSGDISPLAYTIME);
                } else if (orgResponse.status === 1) {
                    message.error(strings.lsOrgExistTxt, MSGDISPLAYTIME);
                } else {
                    message.error(strings.lsAddOrgFailedTxt, MSGDISPLAYTIME);
                }
            } else {
                console.log(orgId);
                let orgResponse: any = await ser.updateSubOrganization(org, orgId);
                if (orgResponse.status === 0) {
                    message.success(strings.lsUpdateOrgSuccessTxt, MSGDISPLAYTIME);
                    if (org.username === storage.getUsername()) {
                     storage.setOrganizationName(org.name);
                    }
                } else if (orgResponse.status === 1) {
                    message.error(strings.lsOrgExistTxt, MSGDISPLAYTIME);
                } else {
                    message.error(strings.lsUpdateOrgFailedTxt, MSGDISPLAYTIME);
                } 
            }
            console.log('this.props', this.props);
            this.props.notifyOrgStatusChange();
            history.back();
        } else {
            // do not do anything
        }
    }

    private async getOrganizationToEdit(id: any) {
        let ser = new service();
        let resp: any = await ser.getOrganization(id);
        if (resp.status === 0 && resp.message === 'NOT FOUND') {
            this.setState({
                unAuth: true,
                organization: []
            });
        } else {
            console.log('getOrganizationresponse', resp);
            this.setState({organization: resp});
        }
    }

    private selectCountry (val: string) {
        this.setState({ country: val });
    }

    private selectRegion(val: string) {
        this.setState({ region: val });
    }

}



// WEBPACK FOOTER //
// ./src/components/organization/OrganizationAddEdit.tsx